let _ = require('lodash');
window.$ = window.jQuery = require('jquery');
$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});

require('slick-carousel')
require('sweetalert')
require('jquery-modal')
require('./contact')
require('./subscribe')
require('./sliders')
require('./instagram')


window.addEventListener('scroll', function() {
  let logo1 = document.getElementById('logo1');
  let logo2 = document.getElementById('logo2');
  logo1.classList.toggle('dnone', window.scrollY > 150)
  if(window.scrollY>150){
    logo2.classList.remove('dnone')
  } else{
    logo2.classList.add('dnone')
  }
})

const navMenu = document.getElementById('nav-menu'),
  toggleMenu = document.getElementById('nav-toggle'),
  closeMenu = document.getElementById('nav-close')

/*SHOW*/
toggleMenu.addEventListener('click', ()=>{
  navMenu.classList.toggle('show')
})

/*HIDDEN*/
closeMenu.addEventListener('click', ()=>{
  navMenu.classList.remove('show')
})

/*PAGERS*/
/* DEPRECEATED
let title = document.title,
up = document.querySelector('.up'),
toAbout = document.querySelector('.toAbout'),
toServices = document.querySelector('.toServices'),
toComments = document.querySelector('.toContact')
if (title != 'Costamatic'){
  up.classList.replace('up','toRoot')
  toAbout.classList.replace('toAbout','toAbout2')
  toServices.classList.replace('toServices' ,'toServices2')
  toComments.classList.replace('toContact' ,'toContact2')
}
*/

/*PAGERS*/
$('.up').click(function () {
  $(window).scrollTop(0);
});
$('.toAbout').click(function () {
  $('html, body').animate({
      scrollTop: $('#about').offset().top - 100
  });
});
$('.toServices').click(function () {
  $('html, body').animate({
      scrollTop: $('#services').offset().top - 100
  });
});
$('.toContact').click(function () {
  $('html, body').animate({
      scrollTop: $('#comments').offset().top - 100
  });
});
$('.toRoot').click(function () {
  $(location).attr("href", "/");
});
$('.toAbout2').click(function () {
  $(location).attr("href", "/#about").offset().top - 100;
});
$('.toServices2').click(function () {
  $(location).attr("href", "/#services").offset().top - 100;
});
$('.toContact2').click(function () {
  $(location).attr("href", "/#comments").offset().top - 100;
});


/*MODALS*/
$('a.modItemSer').click(function(event) {
  $(this).modal({
    clickClose: false,
    showClose: true,
    fadeDuration: 120
  });
  return false;
});

$('a.openCont').click(function(event) {
  $(this).modal({
    clickClose: false,
    showClose: true,
    fadeDuration: 120
  });
  return false;
});

